import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import AzureMachineFilesWidget from "./AzureMachineFilesWidget";
import SharepointFilesWidget from "./SharepointFilesWidget";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";

interface MachineFilesWidgetProps {
  id: string;
  header: string;
}

const MachineFilesWidget = (props: MachineFilesWidgetProps) => {
  const globalParams = useSelector(getParamsSelector);
  return (
      <div style={{ overflowY: "scroll" , height:"100%" } }>
      <div
        style={{
          display: "inline-block",
          verticalAlign: "top",
          marginRight: "100px",
        }}
      >
        <h5>Azure Files</h5>
        <AzureMachineFilesWidget
          id={""}
          header={""}
          machine={globalParams.mainMachineSerialNo}
        />
      </div>
      <div style={{ display: "inline-block", verticalAlign: "top" }}>
        <h5>Sharepoint Files</h5>
        <SharepointFilesWidget
          id={""}
          header={""}
          machine={globalParams.mainMachineSerialNo}
        />
      </div>
    </div>
  );
};
export default MachineFilesWidget;
